import PageModule from "@eisinc/Overrides/Pages/UnhandledErrorModal";

export * from "@eisinc/Overrides/Pages/UnhandledErrorModal";

export default PageModule;
